import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { UploaderOptions } from '../../../domain/public-api';

import { setUploaderOptions } from './settings.actions';
import {
  getAcceptedFileExtensions,
  getAccountId,
  getCropForceAspectRatio,
  getCropMaximumImageSize,
  getIsCropForced,
  getIsMultipleSelection,
} from './settings.selectors';

@Injectable({ providedIn: 'root' })
export class SettingsFacade {
  private readonly store = inject(Store);

  getAcceptedFileExtensions(): Observable<string[]> {
    return this.store.select(getAcceptedFileExtensions);
  }

  getIsCropForced(): Observable<boolean> {
    return this.store.select(getIsCropForced);
  }

  getImageCropForceAspectRatio(): Observable<{ width: number; height: number } | undefined> {
    return this.store.select(getCropForceAspectRatio);
  }

  getImageCropMaximumSize(): Observable<{ width?: number; height?: number } | undefined> {
    return this.store.select(getCropMaximumImageSize);
  }

  getIsMultipleSelection(): Observable<boolean> {
    return this.store.select(getIsMultipleSelection);
  }

  getAccountId(): Observable<string | undefined> {
    return this.store.select(getAccountId);
  }

  setUploaderOptions(options: UploaderOptions): void {
    this.store.dispatch(setUploaderOptions({ options }));
  }
}
